<template>
<div >
  <v-menu >
    <template v-slot:activator="{ on }">
    <v-btn small icon
      v-on='on'
      slot='activator'
      :disabled="disabled" >
      <v-icon>mdi-dots-vertical</v-icon>
    </v-btn>
    </template>
    <v-list dense class="pa-0" >

      <template v-for="action in actions" >
        <v-divider v-if="action.type === 'divider'" :key="`div-${action.id}`" />
        <v-list-item v-else-if="action.visible !== false"
          :key="action.id"
          :disabled="action.disabled"
          :color="action.color"
          @click="setAction(action)" >
          <v-list-item-content>
            <v-list-item-title v-text="action.title" />
          </v-list-item-content>
        </v-list-item>
      </template>

    </v-list>
  </v-menu>
  <v-dialog v-model="dialogVisible" >

      <component
        v-if="activeComponent"
        :is="activeComponent.component"
        v-bind="activeComponent.args"
        :title="activeComponent.title"
        :member="member"
        :practitioner="practitioner"
        :business-id="businessId"
        @saved="saved"
        @close="activeComponent=null" />

  </v-dialog>
</div>
</template>
<script>
import SetPassword from './SetPassword.vue'
import ArchiveMember from './ArchiveMember.vue'
import AddColleague from '@/components/actions/wizards/InviteMemberWizard/AddColleague.vue'
import ToggleMember from './ToggleMember.vue'
import ReactivateAccount from './ReactivateAccount.vue'
// import TransferAppointments from './TransferAppointments.vue'
import ChangeRole from './ChangeRole.vue'

export default {
  name: 'ActionMenu',
  props: {
    context: { type: String, required: false },
    member: { type: Object, required: false },
    practitioner: { type: Object, required: false },
    businessId: { required: false },
    actionId: { type: String, required: false },
    disabled: { type: Boolean, default: false }
  },
  data () {
    return {
      activeComponent: null,
      dialogVisible: false
    }
  },
  methods: {
    setAction (action) {
      this.activeComponent = action
    },
    saved (obj) {
      this.$emit('saved', obj)
    }
  },
  watch: {
    actionId: {
      immediate: true,
      handler () {
        let component = this.actions.find((item) => {
          return (item.id === this.actionId)
        })
        if (component) { this.activeComponent = component }
      }
    },
    activeComponent () {
      if (this.activeComponent) {
        this.$emit('update:actionId', this.activeComponent.id)
        this.dialogVisible = true
      } else {
        this.$emit('update:actionId', null)
        this.dialogVisible = false
      }
    },
    dialogVisible () {
      if (this.dialogVisible === false) { this.activeComponent = false }
    }
  },
  computed: {
    actions () {
      // let isOwner = this.member.role === 'Owner'
      let isNotDependent = (this.practitioner.member_type !== 'Dependent')
      // let vm = this
      let toggleTitle = "Remove from space"
      if (this.member && this.member.is_archived) {
        toggleTitle = "Reactivate space membership"
      }

      return [
        {
          id: 'reset_password',
          title: 'Reset password',
          component: SetPassword,
          args: {},
          disabled: isNotDependent
        },
        {
          id: 'change_role',
          title: 'Change Role',
          component: ChangeRole,
          disabled: !this.member,
          visible: false,
          args: {withRole: true, withPackage: false},
          color: 'error'
        },
        //
        //   id: 'change_package',
        //   title: 'Change package',
        //   component: ChangeRole,
        //   // disabled: isOwner,
        //   args: {withRole: false, withPackage: true},
        //   color: 'error'
        // },
        // { title: 'Send login instructions', disabled: false },
        {
          id: 'add_to_space',
          title: 'Add to another space',
          component: AddColleague,
          disabled: false
        }, // if you own multiple spaces
        {
          id: 'toggle_space',
          title: toggleTitle,
          component: ToggleMember,
          // disabled: isOwner,
          visible: false,
          args: {},
          color: 'error'
        },
        // {
        //   id: 'transfer_assets',
        //   title: 'Transfer assets',
        //   disabled: false,
        //   component: TransferAppointments
        // }, // if you own multiple spaces

        { id: 'div-2', type: 'divider' },
        {
          id: 'archive',
          title: 'Deactivate account',
          component: ArchiveMember,
          // disabled: isOwner,
          // disabled: isNotDependent,
          args: {},
          color: 'error'
        },
        {
          id: 'reactivate_account',
          title: 'Reactivate account',
          component: ReactivateAccount,
          // disabled: isOwner,
          visible: false,
          args: {},
          color: 'error'
        }
      ]
    }
  }
}
</script>
